import React, { useState, useEffect } from "react";
import { loadGoogleAnalytics } from "../../utils/google-analytics";

/**
 * Cookie consent banner — GA4 loads only after Accept.
 */
const CookieConsentBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setIsVisible(true);
    } else if (consent === "accepted") {
      loadGoogleAnalytics();
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setIsVisible(false);
    loadGoogleAnalytics();
  };

  const declineCookies = () => {
    localStorage.setItem("cookie_consent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        backgroundColor: "#333",
        color: "#fff",
        padding: "15px",
        textAlign: "center",
        zIndex: 1000,
      }}
    >
      <p style={{ margin: 0 }}>
        We use cookies to improve your experience. By using our site, you agree
        to our{" "}
        <a
          href="https://map4nomads.com/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#4CAF50", textDecoration: "underline" }}
        >
          Privacy Policy
        </a>
        .
      </p>

      <div style={{ marginTop: "10px" }}>
        <button
          type="button"
          onClick={acceptCookies}
          style={{
            marginRight: "10px",
            padding: "10px 20px",
            backgroundColor: "#4CAF50",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Accept
        </button>
        <button
          type="button"
          onClick={declineCookies}
          style={{
            padding: "10px 20px",
            backgroundColor: "#f44336",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Decline
        </button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
